import isBTMPlan from 'utils/pivot/plan/isBTMPlan'
import getValueFees from 'core/controllerPlans/getValueFees'
import getPlanAsURL from 'core/controllerPlans/getPlanAsURL'
import moneyFormat from 'utils/format/money'
import getAndValidatePeriod from 'utils/pivot/plan/getAndValidateDuration'
import getPlanTypeKey from 'core/controllerPlans/getPlanTypeKey'
import { getBenefits } from 'core/controllerPlans/getBenefits'
import getValidDuration from 'utils/pivot/plan/getValidDuration'

const asMoney = moneyFormat

function parsePlanFromResponse(
  responsePlans,
  planId: string,
  period: number,
  policies: number
): ComparePage.Plan {
  const plan = responsePlans.plans[planId]
  const isBTM = isBTMPlan(plan)
  const duration = isBTM
    ? plan.durations[0]
    : getValidDuration(getAndValidatePeriod(plan, period), policies)

  const isMultiCarrier = plan?.multiCarrierPlan
  const planName = `${plan.planName}${policies > 1 ? ' Added Coverage' : ''}`
  const parsed = { ...plan, planName, period, policies: policies }
  const paidInformationPlan = isMultiCarrier
    ? plan.durations[0].monthly
    : duration.monthly
  parsed.coreBenefits.rxScheduleText = parsed.coreBenefits.rxScheduleDescription
  parsed.monthlyPremium = asMoney(paidInformationPlan.premium)
  parsed.brochure = responsePlans.brochures[parsed.brochureId]
  parsed.carrier = responsePlans.carriers[parsed.carrierId]
  parsed.fee = getValueFees('Application Fee', paidInformationPlan.fees)
  parsed.planAsURL = getPlanAsURL({
    plans: responsePlans.plans,
    planId,
    filters: {
      period,
      policies
    }
  })
  parsed.planTypeKey = getPlanTypeKey(plan)
  parsed.benefits = getBenefits(plan)

  return parsed
}

export default parsePlanFromResponse
